import type { IconData } from '@stacksjs/iconify-core'

export const devicesMicrophone: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M12 0H4v6a4 4 0 1 0 8 0z\"/><path fill=\"currentColor\" d=\"M0 6h2.5a5.5 5.5 0 1 0 11 0H16a8 8 0 0 1-6.5 7.86V16h-3v-2.14A8 8 0 0 1 0 6\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default devicesMicrophone
